module.exports = __webpack_public_path__ + "img/chengdu.e40b30b1.png";